import React, { FC } from "react";
import {
    BrowserRouter,
    Route,
    RouteObject,
    Routes,
    useRoutes,
} from "react-router-dom";

import { About, Landing, NotFoundPage } from "#pages";

import RouteConfig from "config/Routes";

export const AppRouting = () => {
    const routing: RouteObject[] = Object.entries(RouteConfig)
        .filter(o => o[1].routeEnabled)
        .map(([key, value]) => {
            return { path: value.path, element: <value.component /> };
        });
    routing.push({
        element: <NotFoundPage />,
    });
    return useRoutes(routing);
};
